import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-legal-person',
    templateUrl: './legal-person.component.html',
    styleUrls: ['./legal-person.component.scss'],
    standalone: false
})
export class LegalPersonComponent {
@Input() form!: FormGroup;
}
